export enum RoleId {
  PASS = 0,
  DAI = 1,
  STAFF = 2,
  RELATIVE = 3,
  PARTICIPANT = 4,
}
